// CallToAction.js
import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { alpha } from '@mui/material/styles';

/**
 * A call-to-action prompting homeowners to get a free estimate or consultation.
 */
const CallToAction = () => {
  return (
    <Box
      component="section"
      aria-labelledby="landscape-maintenance-cta"
      sx={{
        py: { xs: 4, md: 6 },
        backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.1),
        textAlign: 'center',
      }}
    >
      <Container>
        <Typography
          id="landscape-maintenance-cta"
          variant="h4"
          gutterBottom
          sx={{ fontWeight: 700 }}
        >
          Enhance Your Landscape's Beauty and Health
        </Typography>
        <Typography variant="body1" sx={{ mb: 3, maxWidth: 600, mx: 'auto' }}>
          Let our experts help maintain your outdoor space with professional pruning and mulching services that promote long-term health and beauty.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          size="large"
          href="/contact"
        >
          Schedule a Consultation
        </Button>
      </Container>
    </Box>
  );
};

export default CallToAction;
